// tslint:disable:directive-selector
import {Component, ContentChild, Directive, Input, TemplateRef} from '@angular/core';

@Directive({
    selector: '[asideBody]'
})
export class AsideBodyDirective {
}

@Directive({
    selector: '[leftButtons]'
})
export class AsideLeftButtonsDirective {
}

@Directive({
    selector: '[rightButtons]'
})
export class AsideRightButtonsDirective {
}

@Component({
    selector: 'app-aside-template',
    templateUrl: './aside-template.component.html',
    styleUrls: ['./aside-template.component.less']
})
export class AsideTemplateComponent {
    @Input() title: string;
    @Input() subtitle: string;
    @Input() icon: string;

    @ContentChild(AsideBodyDirective, {read: TemplateRef, static: false}) bodyTemplate;
    @ContentChild(AsideLeftButtonsDirective, {read: TemplateRef, static: false}) leftButtons;
    @ContentChild(AsideRightButtonsDirective, {read: TemplateRef, static: false}) rightButtons;
}
